"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsDefinition = void 0;
const helpers_1 = require("@wix/services-manager/helpers");
exports.TranslationsDefinition = (0, helpers_1.defineService)('viewer-core/translations');
//# sourceMappingURL=index.js.map